export default __webpack_public_path__ + "3f4a78cba51a2cca76ca45d677f34438.svg";